<script>
export default {
  name: "nav",
  data() {
    return {
      sidebar: {
        _name: "CSidebarNav",
        _children: [
          {
            id: 1,
            _name: "CSidebarNavDropdown",
            name: `${this.$t("dashboard")}`,
            icon: "cil-bar-chart",
            permission: 1,
            _children: [
              {
                _name: "CSidebarNavItem",
                name: `${this.$t("dbProductOverview")}`,
                to: "/dashboard/productoverview",
                icon: "cil-bar-chart",
                permission: 1,
              },
              {
                _name: "CSidebarNavItem",
                name: `${this.$t("dbRevenueProduct")}`,
                to: "/dashboard/revenueproduct",
                icon: "cil-bar-chart",
                permission: 1,
              },
              {
                _name: "CSidebarNavItem",
                name: `${this.$t("dbPerformance")}`,
                to: "/dashboard/performance",
                icon: "cil-bar-chart",
                permission: 1,
              },
              {
                _name: "CSidebarNavItem",
                name: `${this.$t("dbCampaign")}`,
                to: "/dashboard/campaign",
                icon: "cil-bar-chart",
                permission: 1,
              },
              {
                _name: "CSidebarNavItem",
                name: `${this.$t("dbProductPerformance")}`,
                to: "/dashboard/productperformance",
                icon: "cil-bar-chart",
                permission: 1,
              },
            ],
          },
          {
            id: 1,
            _name: "CSidebarNavItem",
            name: `${this.$t("product")}`,
            to: "/product",
            icon: "cil-gift",
            permission: 0,
          },
          {
            id: 1,
            _name: "CSidebarNavItem",
            name: `${this.$t("question")} (${this.$store.state.menu.question})`,
            to: "/question",
            icon: "cil-comment-bubble",
            permission: 1,
          },
          {
            id: 1,
            _name: "CSidebarNavItem",
            name: `${this.$t("review")} (${this.$store.state.menu.review})`,
            to: "/review",
            icon: "cil-user",
            permission: 1,
          },
          {
            id: 1,
            _name: "CSidebarNavItem",
            name: `${this.$t("order")} (${this.$store.state.menu.order})`,
            to: "/order",
            icon: "cil-clipboard",
            permission: 1,
          },
          {
            id: 1,
            _name: "CSidebarNavItem",
            name: `${this.$t("resendOrder")}`,
            to: "/resendorder",
            icon: "cil-clipboard",
            permission: 1,
          },
          // {
          //   id: 1,
          //   _name: "CSidebarNavItem",
          //   name: "Profile",
          //   to: "/profile",
          //   icon: "cil-clipboard",
          // },
          {
            id: 1,
            _name: "CSidebarNavItem",
            name: `${this.$t("finance")}`,
            to: "/finance/account-statement",
            icon: "cil-dollar",
            permission: 1,
          },
          {
            id: 1,
            _name: "CSidebarNavItem",
            name: `${this.$t("return")} (${
              this.$store.state.menu.returnOrder
            })`,
            to: "/return",
            icon: "cil-clipboard",
            permission: 1,
          },
          {
            id: 1,
            _name: "CSidebarNavItem",
            name: `${this.$t("article")}`,
            to: "/article",
            icon: "cil-clipboard",
            permission: 1,
          },
          {
            id: 1,
            _name: "CSidebarNavItem",
            name: `${this.$t("campaignList")}`,
            to: "/campaign",
            icon: "cil-bullhorn",
            permission: 1,
          },
          {
            id: 1,
            _name: "CSidebarNavItem",
            name: `${this.$t("chat")}`,
            to: "/chat",
            icon: "cil-speech",
            permission: 1,
          },
          {
            id: 1,
            _name: "CSidebarNavItem",
            name: `${this.$t("faq")}`,
            to: "/faq",
            icon: "cil-speech",
            permission: 1,
          },
          {
            id: 2,
            _name: "CSidebarNavDropdown",
            name: `${this.$t("settings")}`,
            icon: "cil-list",
            permission: 1,
            _children: [
              {
                _name: "CSidebarNavItem",
                name: `${this.$t("bannerList")}`,
                to: "/banner",
                icon: "cil-user",
                permission: 1,
              },
              {
                _name: "CSidebarNavItem",
                name: `${this.$t("promotionList")}`,
                to: "/bannerpromotion",
                icon: "cil-user",
                permission: 1,
              },
              {
                _name: "CSidebarNavItem",
                name: `${this.$t("aboutStore")}`,
                to: "/about-store",
                icon: "cil-user",
                permission: 1,
              },
            ],
          },

          // {
          //   id: 4,
          //   _name: "CSidebarNavItem",
          //   name: "Payment Channel",
          //   to: "/paymentchannel",
          //   icon: "cib-cc-mastercard",
          // },
          // {
          //   id: 29,
          //   _name: "CSidebarNavItem",
          //   name: "Bank",
          //   to: "/bank",
          //   icon: "cil-bank",
          // },
          // {
          //   id: 5,
          //   _name: "CSidebarNavItem",
          //   name: "Line Message Management",
          //   to: "/linemessage",
          //   icon: "cil-chat-bubble",
          // },
          // {
          //   id: 3,
          //   _name: "CSidebarNavItem",
          //   name: "Document",
          //   to: "/document",
          //   icon: "cil-file",
          // },
          // {
          //   id: 2,
          //   _name: "CSidebarNavDropdown",
          //   name: "Feedback",
          //   route: "/Feedback",
          //   icon: "cil-list",
          //   _children: [
          //     {
          //       id: 31,
          //       _name: "CSidebarNavItem",
          //       name: "Feedback List",
          //       to: "/feedback",
          //       icon: "cil-comment-bubble",
          //     },
          //     {
          //       id: 32,
          //       _name: "CSidebarNavItem",
          //       name: "Edit Question/Answer",
          //       to: "/feedback/editfeedbackquestion",
          //       icon: "cil-comment-bubble",
          //     },
          //   ],
          // },
          // {
          //   id: 33,
          //   _name: "CSidebarNavItem",
          //   name: "Notification Settings",
          //   to: "/notification/settings",
          //   icon: "cil-list",
          // },
          // {
          //   id: 34,
          //   _name: "CSidebarNavItem",
          //   name: "Promotion",
          //   to: "/promotion",
          //   icon: "cil-bullhorn",
          // },
          // {
          //   id: 7,
          //   _name: "CSidebarNavDropdown",
          //   name: "Report",
          //   route: "/report",
          //   icon: "cil-list",
          //   _children: [
          //     {
          //       id: 8,
          //       _name: "CSidebarNavItem",
          //       name: "Barcode/QRCode",
          //       to: "/report/barcode",
          //       icon: "cil-file",
          //     },
          //     {
          //       id: 9,
          //       _name: "CSidebarNavItem",
          //       name: "Online Payment",
          //       to: "/report/onlinePayment",
          //       icon: "cil-file",
          //     },
          //     {
          //       id: 10,
          //       _name: "CSidebarNavItem",
          //       name: "Map",
          //       to: "/report/map",
          //       icon: "cil-file",
          //     },
          //     {
          //       id: 11,
          //       _name: "CSidebarNavItem",
          //       name: "Check App",
          //       to: "/report/checkapp",
          //       icon: "cil-file",
          //     },
          //     {
          //       id: 35,
          //       _name: "CSidebarNavItem",
          //       name: "Calculator",
          //       to: "/report/calculator",
          //       icon: "cil-file",
          //     },
          //     {
          //       id: 12,
          //       _name: "CSidebarNavDropdown",
          //       name: "Contract",
          //       icon: "cil-list",
          //       _children: [
          //         {
          //           id: 13,
          //           name: "Unregister",
          //           to: "/report/unregister",
          //           icon: "cil-file",
          //         },
          //         {
          //           id: 14,
          //           name: "OTP",
          //           to: "/report/otp",
          //           icon: "cil-file",
          //         },
          //         {
          //           id: 15,
          //           name: "Contract Infomation",
          //           to: "/report/contractInfomation",
          //           icon: "cil-file",
          //         },
          //         {
          //           id: 16,
          //           name: "Request Contract",
          //           to: "/report/requestContract",
          //           icon: "cil-file",
          //         },
          //         {
          //           id: 17,
          //           name: "Register Line Connect",
          //           to: "/report/register",
          //           icon: "cil-file",
          //         },
          //         {
          //           id: 18,
          //           name: "Installment Information",
          //           to: "/report/installment",
          //           icon: "cil-file",
          //         },
          //       ],
          //     },
          //     {
          //       id: 19,
          //       _name: "CSidebarNavDropdown",
          //       name: "Notification",
          //       icon: "cil-list",
          //       _children: [
          //         {
          //           id: 20,
          //           name: "Notification Installment",
          //           to: "/report/notiInstallment",
          //           icon: "cil-file",
          //         },
          //         {
          //           id: 21,
          //           name: "Notification Overdue",
          //           to: "/report/notiOverdue",
          //           icon: "cil-file",
          //         },
          //         {
          //           id: 22,
          //           name: "Notification Overdue 1",
          //           to: "/report/notiOverdue1",
          //           icon: "cil-file",
          //         },
          //         {
          //           id: 23,
          //           name: "Notification Receipt",
          //           to: "/report/notiReceipt",
          //           icon: "cil-file",
          //         },
          //         {
          //           id: 24,
          //           name: "Notification Receipt Cancel",
          //           to: "/report/notiReceiptCancel",
          //           icon: "cil-file",
          //         },
          //         {
          //           id: 25,
          //           name: "Notification Return Cash",
          //           to: "/report/notiReturnCash",
          //           icon: "cil-file",
          //         },
          //         {
          //           id: 26,
          //           name: "Notification RI",
          //           to: "/report/notiRi",
          //           icon: "cil-file",
          //         },
          //         {
          //           id: 27,
          //           name: "Notification Tax",
          //           to: "/report/notiTax",
          //           icon: "cil-file",
          //         },
          //         {
          //           id: 28,
          //           name: "Notification Point Expire",
          //           to: "/report/notiPoint",
          //           icon: "cil-file",
          //         },
          //       ],
          //     },
          //   ],
          // },
          // {
          //   id: 6,
          //   _name: "CSidebarNavItem",
          //   name: "Admin",
          //   to: "/admin",
          //   icon: "cil-star",
          // },
        ],
      },
      test: 0,
      permissionList: [0, 1],
    };
  },
  computed: {
    sidebarItems() {
      return [
        {
          _name: "CSidebarNav",
          _children: this.filterMenuByPermission(this.sidebar._children),
        },
      ];
    },
  },
  beforeCreate: async function () {
    await this.$store.dispatch("getActiveData");
    await this.getPermissionList();
  },
  created() {},
  methods: {
    getPermissionList: async function () {
      if (this.$store.state.profile.isAdmin) {
        this.permissionList = [0];
      } else {
        this.permissionList = [0, 1];
      }
    },
    filterMenuByPermission(list) {
      var menus = this.filterPermission(list);
      menus.forEach((element) => {
        if (element._children) {
          element._children = this.filterPermission(element._children);
          element._children.forEach((element2) => {
            if (element2._children) {
              element2._children = this.filterPermission(element2._children);
            }
          });
        }
      });

      return menus;
    },
    filterPermission(list) {
      var t = list.filter((item) => {
        return this.permissionList.indexOf(item.permission) > -1;
      });
      return t;
    },
  },
};
</script>
